<template >
  <v-container >
    <v-layout justify-centerv-if="overlay">
       <v-dialog v-model="overlay" persistent max-width="600">
         <v-card>
           <v-card-text>
              <v-progress-linear
                indeterminate
                color="#4EABDD"
              ></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
    </v-layout>
    <v-layout justify-center>
      <v-dialog v-model="DialogPosizioneEtichetta2" persistent max-width="600">
        <v-form v-model="valido1" ref="posizione_etichetta_singola">
          <v-card>
            <v-card-title class="headline">POSIZIONE ETICHETTA</v-card-title>
            <v-card-text >Gentile utente, da quale etichetta vuoi iniziare a stampare? Seleziona il bottone relativo alla posizione della prima etichetta da stampare</v-card-text>
            <v-card-text style="text-align: center; "><v-btn style="color: white;" :color="colore1" @click="Attiva(1)">1</v-btn><v-btn style="color: white;" :color="colore2" @click="Attiva(2)">2</v-btn></v-card-text>
            <v-card-text style="text-align: center; "><v-btn style="color: white;" :color="colore3" @click="Attiva(3)">3</v-btn><v-btn style="color: white;" :color="colore4" @click="Attiva(4)">4</v-btn></v-card-text>
            <v-card-text style="text-align: center; "><v-btn style="color: white;" :color="colore5" @click="Attiva(5)">5</v-btn><v-btn style="color: white;" :color="colore6" @click="Attiva(6)">6</v-btn></v-card-text>
            
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn :disabled="!valido1" large style="box-shadow: none; color: white;" color="#4EABDD" text @click="DialogPosizioneEtichetta2=false; StampaEtichetteA4();">OK</v-btn>
              <v-btn large style="box-shadow: none; color: white;" color="#4EABDD" @click="DialogPosizioneEtichetta2=false; posizioneStampa=1;Attiva(1);">ANNULLA</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-layout>
    <v-layout justify-center>
      <v-dialog v-model="DialogPosizioneEtichetta" persistent max-width="600">
        <v-form v-model="valido" ref="posizione_etichetta">
          <v-card>
            <v-card-title class="headline">POSIZIONE ETICHETTA</v-card-title>
            <v-card-text >Gentile utente, da quale etichetta vuoi iniziare a stampare? Seleziona il bottone relativo alla posizione della prima etichetta da stampare</v-card-text>
            <v-card-text style="text-align: center; "><v-btn style="color: white;" :color="colore1" @click="Attiva(1)">1</v-btn><v-btn style="color: white;" :color="colore2" @click="Attiva(2)">2</v-btn></v-card-text>
            <v-card-text style="text-align: center; "><v-btn style="color: white;" :color="colore3" @click="Attiva(3)">3</v-btn><v-btn style="color: white;" :color="colore4" @click="Attiva(4)">4</v-btn></v-card-text>
            <v-card-text style="text-align: center; "><v-btn style="color: white;" :color="colore5" @click="Attiva(5)">5</v-btn><v-btn style="color: white;" :color="colore6" @click="Attiva(6)">6</v-btn></v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn :disabled="!valido" large style="box-shadow: none; color: white;" color="#4EABDD" text @click="DialogPosizioneEtichetta=false; StampaEtichetteMultipleA4();">OK</v-btn>
              <v-btn large style="box-shadow: none; color: white;" color="#4EABDD" @click="DialogPosizioneEtichetta=false; posizioneStampa=1;Attiva(1);">ANNULLA</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-layout>
    <v-layout justify-center>
      <v-dialog v-model="erroreInvioDialog" persistent max-width="600">
        <v-card>
          <v-card-title class="headline">ERRORE DI INVIO BOLLE</v-card-title>
          <v-card-text v-html="testoErroreInvio">{{ testoErroreInvio }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn large style="box-shadow: none; color: white;" color="#4EABDD" text @click="erroreInvioDialog=false">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout justify-center>
      <v-dialog v-model="mostraErrore" persistent max-width="600">
        <v-card>
          <v-card-title class="headline">ERRORE STAMPA</v-card-title>
          <v-card-text v-html="erroreStampa" >{{ erroreStampa }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn large style="box-shadow: none; color: white;" color="#4EABDD" text @click="mostraErrore=false">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout justify-center>
      <v-dialog v-model="dialogMod" persistent max-width="600">
        <v-card>
          <v-card-title class="headline">DUPLICAZIONE BOLLA</v-card-title>
          <v-card-text >Gentile utente,</v-card-text>
          <v-card-text >Confermi di voler annullare la spedizione numero: {{ spedMod }} e duplicarla?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn large style="box-shadow: none; color: white;" color="#4EABDD" text @click="CheckModBolla()">SI - CONFERMA</v-btn>
            <v-btn large style="box-shadow: none; color: white;" color="#A0A4A7" text @click="dialogMod = false">NO - TORNA INDIETRO</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout justify-center>
      <v-dialog v-model="dialogDelete" persistent max-width="600">
        <v-card>
          <v-card-title class="headline">ELIMINAZIONE BOLLA</v-card-title>
          <v-card-text >Gentile utente,</v-card-text>
          <v-card-text >Confermi di voler eliminare la spedizione numero: {{ spedDelete }}?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn large style="box-shadow: none; color: white;" color="#4EABDD" text @click="CheckDeleteBolla()">OK - CANCELLA</v-btn>
            <v-btn large style="box-shadow: none; color: white;" color="#A0A4A7" text @click="dialogDelete = false">NO - TORNA INDIETRO</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout justify-center>
      <v-dialog v-model="importazioneFinita" persistent max-width="600">
        <v-card>
          <v-card-title class="headline">IMPORTAZIONE CONCLUSA</v-card-title>
          <v-card-text >Gentile utente,</v-card-text>
          <v-card-text >le tue spedizioni sono state importate nei nostri sistemi.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn large style="box-shadow: none; color: white;" color="#4EABDD" text @click="OkimportazioneFinita()">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout justify-center>
      <v-dialog v-model="importazioneErrore" persistent max-width="600">
        <v-card>
          <v-card-title class="headline">ERRORE IMPORTAZIONE</v-card-title>
          <v-card-text >Gentile utente,</v-card-text>
          <v-card-text >Qualcosa impedisce l'inserimento automatico delle tue spedizioni.</v-card-text>
          <v-card-text >Verifica che il file excel sia corretto e generato con una versione di excel superiore alla 2003.</v-card-text>
          <v-card-text >Nel caso l'errore persista, contattare l'assistenza.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn large style="box-shadow: none; color: white;" color="#4EABDD" text @click="importazioneErrore = false">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout justify-center>
      <v-dialog v-model="erroreStatiDialog" persistent max-width="800">
        <v-card>
            <v-card-title>
                <span class="headline">ATTENZIONE</span></v-card-title>
            <v-card-text>
                Gentile utente, è possibile inviare solo le bolle di cui sono stati stampati i segnacolli.
                    </v-card-text>
                    <v-card-actions><v-btn large style="box-shadow: none; color: white;" color="#4EABDD" @click="erroreStatiDialog = false">OK</v-btn></v-card-actions>
            </v-card>
        </v-dialog>
      </v-layout>
    <v-card>
      <v-container>
        <v-layout justify-center row wrap>
          <v-flex xs12 sm12 md12>
            <h1>{{$t('key135')}}: </h1>
          </v-flex>
        
        <v-flex xs12 sm6 md4>
          <v-dialog
            ref="dialog"
            v-model="dataP"
            :return-value.sync="data_partenza"
            persistent
            lazy
            full-width
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                
                v-model="data_partenza"
                :label="$t('key136')"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker locale="it-IT" v-model="data_partenza" scrollable :min="minPartenza" :max="maxPartenza" @input="$refs.dialog.save(data_partenza)">
              <v-spacer></v-spacer>
              <v-btn flat color="#4EABDD" @click="dataP = false">Annulla</v-btn>
              <v-btn flat color="#4EABDD" @click="checkFinale">OK</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-flex>

        <v-spacer></v-spacer>
        <v-flex xs12 sm6 md4>
          <v-dialog
            ref="dialog2"
            v-model="dataF"
            :return-value.sync="data_finale"
            persistent
            lazy
            full-width
            width="290px"
          >
            <v-spacer></v-spacer>
            <template v-slot:activator="{ on }">
              <v-text-field
                
                v-model="data_finale"
                :label="$t('key137')"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker locale="it-IT" v-model="data_finale" scrollable :min="data_partenza" :max="maxFinale" @input="$refs.dialog2.save(data_finale)">
              <v-spacer></v-spacer>
              <v-btn flat color="#4EABDD" @click="dataF = false">Annulla</v-btn>
              <v-btn flat color="#4EABDD" @click="$refs.dialog2.save(data_finale)">OK</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-btn large style="box-shadow: none; color: white;" color="#4EABDD" @click="OpenManuale">MANUALE BOLLETTAZIONE</v-btn>
        </v-flex>

        <v-flex xs12 sm6 md4>
          <v-text-field  :label="$t('key138')" v-model="ddt_partenza"></v-text-field>
        </v-flex> 
        <v-spacer></v-spacer>
        <v-flex xs12 sm6 md4>
          <v-text-field  :label="$t('key352')" v-model="ddt_finale"></v-text-field>
        </v-flex>
        <v-flex xs0 sm0 md3>
          </v-flex>
        <v-flex xs12 sm6 md4>
        <v-select
            
            v-model="stato"
            v-bind:items="Stati"
            :label="$t('key139')"
            @change="GetStati"
          ></v-select>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex xs12 sm6 md4>
            <v-btn large style="box-shadow: none; color: white;" color="#A0A4A7" @click="Cerca"> {{$t('key145')}} </v-btn>
          </v-flex>
        <v-flex xs0 sm0 md3>
          </v-flex>
          
          <v-flex xs0 sm0 md12>
          </v-flex>
          <v-flex xs12 sm6 md2>
            <v-btn large style="box-shadow: none; color: white; margin-left: 0px;" color="#A0A4A7" @click="Inserisci"> {{$t('key146')}} </v-btn>
          </v-flex>
          <v-flex xs12 sm6 md2>
          <upload-button large style="box-shadow: none; color: white;" v-if="mostra_excel" lazy title="CARICA FILE EXCEL" noTitleUpdate @file-update="fileSelectedFunc"></upload-button>
          </v-flex>
          <v-flex xs12 sm6 md2>
            <v-btn large style="box-shadow: none; color: white;" color="#A0A4A7" @click="ChiediPosizioneEtichetta()"> {{$t('key148')}} </v-btn>
          </v-flex>
          <v-flex xs12 sm6 md2>
            <v-btn large style="box-shadow: none; color: white;" color="#A0A4A7" v-if="mostra10 !== 0" @click="StampaEtichetteMultiple()"> {{$t('key149')}} </v-btn>
          </v-flex>
          <v-flex xs12 sm6 md2>
            <v-btn large style="box-shadow: none; color: white;" color="#A0A4A7" @click="InvioBolle"> {{$t('key147')}} </v-btn>
          </v-flex>
          <v-flex xs0 sm6 md2>
          </v-flex>
          <v-flex xs12 sm6 md4>
            <v-btn large style="box-shadow: none; color: white; margin-left: 0px;" color="#A0A4A7" @click="StampaDistinta(DistSelezionata)"> {{$t('key150')}} </v-btn>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm6 md3>
        <v-select
            
            v-model="DistintaSelezionata"
            v-bind:items="Distinte"
            :label="$t('key151')"
            @change="GetDistinte"
          ></v-select>
        </v-flex>
        <v-flex xs12 sm6 md5>
          <v-checkbox
                v-if="DistSelezionata !== '' && DistSelezionata !== null && DistSelezionata !== undefined"
                label="Stampa LDV"
                v-model="ristampaLDV"
              ></v-checkbox>
        </v-flex>
        <!--
        <v-spacer></v-spacer>
        <v-flex xs0 sm0 md3>
          </v-flex>
          <v-flex xs12 sm6 md3>
        </v-flex>
        -->
        </v-layout>
        <v-layout>
        <v-flex xs2 sm2 md2>
          <v-text-field :label="$t('key152')" v-model="totaleSpedizioni"></v-text-field>
        </v-flex>
        <v-flex xs2 sm2 md1>
          <v-text-field :label="$t('key153')" v-model="totaleColli"></v-text-field>
        </v-flex>
        <v-flex xs2 sm2 md1>
          <v-text-field :label="$t('key154')" v-model="totalePeso"></v-text-field>
        </v-flex>
        <v-flex xs2 sm2 md1>
          <v-text-field :label="$t('key155')" v-model="totaleVolume"></v-text-field>
        </v-flex>
        <v-flex xs2 sm2 md2>
          <v-text-field :label="$t('key156')" v-model="totaleContrassegno"></v-text-field>
        </v-flex>
        <!--
        <v-flex xs2 sm2 md5>
          </v-flex>
        -->
        </v-layout>
         <!-- <v-data-table
            v-model="selected"
            :headers="headers"
            v-bind:items="items"
            item-key="name"
            show-select
            class="elevation-1"
          >
            
        </v-data-table> -->
        <v-flex xs12 sm12 md12>
        <v-data-table
          :headers="headers"
          :items="items"
          :single-select="singleSelect"
          sort-by="numspe"
          :sort-asc= true
          v-model="selected"
          item-key="numspe"
          select-all
          class="elevation-1"
          :pagination.sync="pagination"
        >
        
          <template slot="items" slot-scope="props">
            
            
              <th class="text-xs-left" ><v-checkbox
                
                :input-value="props.all"
                :indeterminate="props.indeterminate"
                primary
                hide-details
                @click.stop="toggleAll"
              ></v-checkbox></th>
              
                </template>
    <template v-slot:items="props">
            <tr >
              <td :active="props.selected" @click="props.selected = !props.selected">
                <v-checkbox
                  :input-value="props.selected"
                  primary
                  hide-details
                  v-if="props.item.stato !== 'INVIATA'"
                  @change="test(props.selected,props.item)"
                ></v-checkbox>
              </td>
            
              <td class="text-xs-left"  @click="BollettazioneRiepilogo(props.item.numspe, props.item.stato)"><strong>{{ props.item.numspe }}</strong></td>
              <td class="text-xs-left"  @click="BollettazioneRiepilogo(props.item.numspe, props.item.stato)">{{ props.item.datins.substr(0,10) }}</td>
              <!-- <td class="text-xs-left" v-bind:style="{ backgroundColor : props.item.stato === 'INSERITA'?'#F4F4F4' : props.item.stato === 'SEGN.LI STAMPATI'? 'yellow' : props.item.stato === 'INVIATA'?'green':'red' }"  @click="BollettazioneRiepilogo(props.item.numspe, props.item.stato)">{{ props.item.stato }}</td> -->
              <td class="text-xs-left" v-bind:style="{ backgroundColor : '#F4F4F4' }"  @click="BollettazioneRiepilogo(props.item.numspe, props.item.stato)">{{ props.item.stato }}</td>
              <td class="text-xs-left"  @click="BollettazioneRiepilogo(props.item.numspe, props.item.stato)">{{ props.item.desrag }}</td>
              <td class="text-xs-left"  @click="BollettazioneRiepilogo(props.item.numspe, props.item.stato)">{{ props.item.desind }}</td>
              <td class="text-xs-left"  @click="BollettazioneRiepilogo(props.item.numspe, props.item.stato)">{{ props.item.desloc }}</td>
              <td class="text-xs-left"  @click="BollettazioneRiepilogo(props.item.numspe, props.item.stato)">{{ props.item.numcol }}</td>
              <td class="text-xs-left"  @click="BollettazioneRiepilogo(props.item.numspe, props.item.stato)">{{ props.item.numddt }}</td>
              <td class="text-xs-left"  @click="BollettazioneRiepilogo(props.item.numspe, props.item.stato)">{{ props.item.contra === 0?"--":props.item.contra }}</td>
              <!-- <td :hidden="props.item.stato ==='ERRORE' || props.item.stato ==='INVIATA'" class="text-xs-center"  @click="StampaEtichette(props.item.numspe)"><v-icon >print</v-icon></td>
              <td v-if="props.item.stato ==='ERRORE' || props.item.stato ==='INVIATA'" class="text-xs-center">--</td>
              <td :hidden="props.item.stato ==='ERRORE' || props.item.stato ==='INVIATA'" class="text-xs-center"  @click="StampaEtichetteA4(props.item.numspe)"><v-icon >print</v-icon></td>
              <td v-if="props.item.stato ==='ERRORE' || props.item.stato ==='INVIATA'" class="text-xs-center">--</td>
              <td  :hidden="props.item.stato ==='ERRORE' || props.item.stato !== 'INVIATA'" class="text-xs-center"  @click="StampaLdv(props.item.numspe)"><v-icon >print</v-icon></td>
              <td v-if="props.item.stato ==='ERRORE' || props.item.stato !== 'INVIATA'" class="text-xs-center">--</td> -->
              <td>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" v-if="!(props.item.stato ==='ERRORE' || props.item.stato ==='INVIATA' || mostra10 === 0)" class="text-xs-center"  @click="StampaEtichette(props.item.numspe)">format_shapes</v-icon>
                  </template>
                    <span>Stampa etichette 10 x 10</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" v-if="!(props.item.stato ==='ERRORE' || props.item.stato ==='INVIATA')" class="text-xs-center"  @click="ChiediPosizioneEtichettaSingola(props.item.numspe)">print</v-icon>
                  </template>
                    <span>Stampa etichette A4</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" v-if="!(props.item.stato ==='ERRORE' || props.item.stato !== 'INVIATA')" class="text-xs-center"  @click="StampaLdv(props.item.numspe)">assignment</v-icon>
                </template>
                    <span>Stampa LDV</span>
                </v-tooltip>
                </td>
              <td  >
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                <v-icon v-on="on" v-if="(props.item.stato ==='ERRORE INSTRADAMENTO' || props.item.stato ==='INSERITA' || props.item.stato === 'SEGN.LI STAMPATI' || props.item.stato === 'ERRORE')" class="text-xs-center"  @click="CancellaBolla(props.item.numspe)">delete</v-icon>
                </template>
                    <span>Cancella bolla</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
              <v-icon v-on="on" v-if="!(props.item.stato ==='ERRORE' || props.item.stato !== 'SEGN.LI STAMPATI')" class="text-xs-center"  @click="DuplicaBolla(props.item.numspe)">create</v-icon>
              </template>
                    <span>Annulla &amp; Duplica</span>
                </v-tooltip>
              </td>
              
            </tr>
          </template>
          <template
            slot="pageText"
            slot-scope="{ pageStart, pageStop }"
          >From {{ pageStart }} to {{ pageStop }}</template>
        </v-data-table>
        </v-flex>
      </v-container>
      

    </v-card>
  </v-container>
</template>


<script>
import axios from "axios";
import UploadButton from 'vuetify-upload-button';
export default {
components: {
      'upload-button': UploadButton
    },
  data: () => ({
    DialogPosizioneEtichetta2: false,
    valido: true,
    valido1: true,
    DistintaSelezionata: "",
    dataP: false,
    overlay: false,
    decodificaStato: [],
    pagination: { 'sortBy': 'numspe', 'descending': true, rowsPerPage: 25 },
    dataF: false,
    data_partenza: "",
    data_finale: "",
    importazioneFinita: false,
    minPartenza: "",
    maxPartenza: "",
    minFinale: "",
    maxFinale: "",
    ddt_partenza: "",
    mostra_excel : false,
    stato: {text: "ALL", value: 0},
    ddt_finale: "",
    DistSelezionata: "",
    Stati_it: [
      {text: "TUTTE", value: 0},
      {text: "INSERITA", value: 1},
      {text: "SEGNACOLLI STAMPATI", value: 2},
      {text: "INVIATA", value: 3},
      {text: "ERRORE", value: -1},
    ],
    Stati_en: [
      {text: "ALL", value: 0},
      {text: "ENTERED", value: 1},
      {text: "PRINTED LABELS", value: 2},
      {text: "SENT", value: 3},
      {text: "ERROR", value: -1},
    ],
    Stati: [],
    headers_it: [
     
      { text: "Numero spedizione", align: "left", value: "numspe" },
      { text: "Data bolla", align: "left", value: "datins" },
      { text: "Stato", align: "left", value: "stato" },
      { text: "Ragione Sociale", align: "left", value: "desrag" },
      { text: "Indirizzo", align: "left", value: "desind" },
      { text: "Località", align: "left", value: "desloc" },
      { text: "Colli", align: "left", value: "numcol"},
      { text: "Ddt", align: "left", value: "numddt"},
      { text: "Contrassegno", align: "left", value: "contra" },
      { text: "Stampe", align: "left", value: "eti" },
      // { text: "Stampa A4", align: "left", value: "eti" },
      // { text: "Stampa LDV", align: "left", value: "ldv" },
      { text: "Duplica / Cancella", align: "left", value: "" },
      
      
    ],
    headers_en: [
     
      { text: "Shipment number", align: "left", value: "numspe" },
      { text: "Shipment date", align: "left", value: "datins" },
      { text: "Status", align: "left", value: "stato" },
      { text: "Consignee business name", align: "left", value: "desrag" },
      { text: "Address", align: "left", value: "desind" },
      { text: "Town", align: "left", value: "desloc" },
      { text: "Colli", align: "left", value: "numcol"},
      { text: "Customer reference", align: "left", value: "numddt"},
      { text: "COD", align: "left", value: "contra" },
      { text: "Prints", align: "left", value: "eti" },
      // { text: "Stampa A4", align: "left", value: "eti" },
      // { text: "Stampa LDV", align: "left", value: "ldv" },
      { text: "Duplicate / Delete", align: "left", value: "" },
      
      
    ],
    headers: [],
    items: [],
    statoSelezionato: 0,
    selezionati: [],
    selected: false,
    selezionaTutto: false,
    totaleSpedizioni : 0,
    totaleColli: 0,
    totalePeso: 0,
    totaleVolume: 0,
    selected: [],
    totaleContrassegno: 0,
    singleSelect: false,
    dataToBeWatched: "",
    uploaded: "",
    estensione: "",
    Distinte: [],
    erroreStatiDialog : false,
    erroreStati: false,
    importazioneErrore: false,
    dialogDelete: false,
    spedDelete : "",
    dialogMod: false,
    spedMod : "",
    erroreStampa: "",
    mostraErrore: false,
    erroreInvioDialog: false,
    testoErroreInvio: "",
    mostra10: 0,
    motivoCancellazione: "",
    ristampaLDV: false,
    DialogPosizioneEtichetta : false,
    posizioneStampa: 1,
    DaStampare: "",
    permessoStampaPosizionale: 0,
    colore1: "blue",
    colore2: "light grey",
    colore3: "grey",
    colore4: "grey",
    colore5: "grey",
    colore6: "grey"

    

  }),
  created(){
    this.$store.dispatch("ImpostaScollegamento");
  },
  mounted() {
    if(this.$i18n.locale=='it') {
      this.Stati = this.Stati_it;
      this.headers = this.headers_it;
    } else {
      this.Stati = this.Stati_en;
      this.headers = this.headers_en;
    }
    this.CheckJWT();
    this.PermessoStampa10();
    this.checkPermessi();
    this.data_partenza = new Date().toISOString().substr(0, 10);
    this.data_finale = new Date().toISOString().substr(0, 10);
    this.decodificaStato["ERRORE"] = -1;
    this.decodificaStato["INVIATA"] = 3;
    this.decodificaStato["SEGN.LI STAMPATI"] = 2;
    this.decodificaStato["INSERITA"] = 1;
    this.decodificaStato["ERRORE INSTRADAMENTO"] = -2;
    
    if(this.$store.state.filtri_bollettazione.data_partenza){
      this.data_partenza = this.$store.state.filtri_bollettazione.data_partenza;
      this.data_finale = this.$store.state.filtri_bollettazione.data_finale;
      this.minPartenza = this.$store.state.filtri_bollettazione.minPartenza; 
      this.maxPartenza = this.$store.state.filtri_bollettazione.maxPartenza;
      this.minFinale = this.$store.state.filtri_bollettazione.minFinale;
      this.maxFinale = this.$store.state.filtri_bollettazione.maxFinale;
      this.ddt_partenza = this.$store.state.filtri_bollettazione.ddtPartenza;
      this.ddt_finale = this.$store.state.filtri_bollettazione.ddtFinale;
      this.stato = {value: this.$store.state.filtri_bollettazione.statoSpedizione};
      this.statoSpedizione = this.$store.state.filtri_bollettazione.statoSpedizione;
      this.items = this.$store.state.items_bollettazione;
      this.Cerca();
      
    }
    else{
      this.data_partenza = new Date().toISOString().substr(0, 10);
      this.data_finale = new Date().toISOString().substr(0, 10);
      this.minPartenza = this.addDays(new Date(), -365)
          .toISOString()
          .substr(0, 10);
      this.maxPartenza = new Date().toISOString().substr(0, 10);
      this.minFinale = this.data_partenza;
      this.maxFinale = new Date().toISOString().substr(0, 10);
      this.Cerca();
     
    }
    
  },
  methods: {
    Attiva(bottoneAttivo){
      switch(bottoneAttivo){
        case 1:
          this.colore1 = "blue";
          this.colore2 = "grey";
          this.colore3 = "grey";
          this.colore4 = "grey";
          this.colore5 = "grey";
          this.colore6 = "grey";
          this.posizioneStampa = 1;
          break;
        case 2:
          this.colore1 = "grey";
          this.colore2 = "blue";
          this.colore3 = "grey";
          this.colore4 = "grey";
          this.colore5 = "grey";
          this.colore6 = "grey";
          this.posizioneStampa = 2;
          break;
        case 3:
          this.colore1 = "grey";
          this.colore2 = "grey";
          this.colore3 = "blue";
          this.colore4 = "grey";
          this.colore5 = "grey";
          this.colore6 = "grey";
          this.posizioneStampa = 3;
          break;
        case 4:
          this.colore1 = "grey";
          this.colore2 = "grey";
          this.colore3 = "grey";
          this.colore4 = "blue";
          this.colore5 = "grey";
          this.colore6 = "grey";
          this.posizioneStampa = 4;
          break;
        case 5:
          this.colore1 = "grey";
          this.colore2 = "grey";
          this.colore3 = "grey";
          this.colore4 = "grey";
          this.colore5 = "blue";
          this.colore6 = "grey";
          this.posizioneStampa = 5;
          break;
        case 6:
          this.colore1 = "grey";
          this.colore2 = "grey";
          this.colore3 = "grey";
          this.colore4 = "grey";
          this.colore5 = "grey";
          this.colore6 = "blue";
          this.posizioneStampa = 6;
          break;
        
      }
    },
    isInteger( evt ) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
                evt.preventDefault();
            } else {
                return true;
            }            
      },
    OpenManuale(){
      window.open('https://clienti.arcospedizioni.it/download/manbol.pdf');
    },
    fileSelectedFunc(upload){
      this.overlay = true;
        //if(upload.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || upload.type == "application/vnd.ms-excel"){
          //if(upload.type == "application/vnd.ms-excel"){
          this.estensione = "xls"
          //}
          if(upload.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"){
            this.estensione = "xlsx"
          }
          const fr = new FileReader();
          fr.readAsDataURL(upload);
          this.uploaded = fr.result;
          fr.addEventListener("load", () => {
            this.uploaded = fr.result;
            axios.post(this.$store.state.servicePath + "/api/Excel",
          {
            stream: this.uploaded,
            nome: upload.name,
            estensione: this.estensione
          }).then(res=>{
            if(res.status < 400)
                this.overlay = false;
                this.Cerca();
                this.importazioneFinita = true;
                
          })
          .catch(err=>{
            this.overlay = false;
            this.importazioneErrore = true;
          });
          
          
            // you can now do other things with the imageFile, like send it to your server
          });
          
        //}
      
      
    },
    addDays(date, days) {
      date.setDate(date.getDate() + days);
      return date;
    },
    checkFinale() {
      this.$refs.dialog.save(this.data_partenza);
      this.minFinale = this.data_partenza;
      this.maxFinale = new Date().toISOString().substr(0, 10);
    },
    GetStati(value){
      this.statoSpedizione = value;
    },
    GetDistinte(e){
      this.DistSelezionata = e;
    },
    Cerca(){
      
      var filtri = {};
      filtri.data_partenza = this.data_partenza;
      filtri.minPartenza = this.minPartenza;
      filtri.maxPartenza = this.maxPartenza;
      filtri.data_finale = this.data_finale;
      filtri.minFinale = this.minFinale;
      filtri.maxFinale = this.maxFinale;
      if(this.ddt_partenza !== null && this.ddt_partenza !== "" &&(this.ddt_finale === null || this.ddt_finale === ""))
        this.ddt_finale = this.ddt_partenza.replace("'", "''");
      if(this.ddt_finale !== null && this.ddt_finale !== "" &&(this.ddt_partenza === null || this.ddt_partenza === ""))
        this.ddt_partenza = this.ddt_finale.replace("'", "''");
      filtri.ddtPartenza = this.ddt_partenza.replace("'", "''");
      filtri.ddtFinale = this.ddt_finale.replace("'", "''");
      filtri.statoSpedizione = this.statoSpedizione;
      this.$store.commit("setFiltriBollettazione", filtri);
      axios.post(this.$store.state.servicePath + "/api/ArBolleSpes/Search", {
        dataPartenza: this.data_partenza,
        dataFinale: this.data_finale+"T23:59:59",
        ddtPartenza: this.ddt_partenza === ""?null:this.ddt_partenza,
        ddtFinale: this.ddt_finale === ""?null:this.ddt_finale,
        statoSpedizione: this.statoSpedizione,
      }).
            then(res=> {
              this.Distinte = [];
                this.items = [];
                res.data.forEach(el => {
                  el.stato = el.stato === -1?"ERRORE":el.stato===1?"INSERITA":el.stato === 3?"INVIATA":el.stato === 2?"SEGN.LI STAMPATI":el.stato === -2?"ERRORE INSTRADAMENTO":el.stato;
                  if(el.desrag == null){
                    el.desrag = "";
                  }
                  if(el.desind == null){
                    el.desind = "";
                  }
                  if(el.desloc == null){
                    el.desloc = "";
                  }
                  if(el.numddt == null){
                    el.numddt = "";
                  }
                  el.desrag = el.desrag.replace("''", "'");
                  el.desind = el.desind.replace("''", "'");
                  el.desloc = el.desloc.replace("''", "'");
                  el.numddt = el.numddt.replace("''", "'");
                  
                  this.items.push(el);
                  if(el.datdis != null)
                  {
                    this.Distinte.push(el.datdis)
                  }
                })
                this.$store.commit("setItemsBollettazione", this.items);
                this.DistSelezionata = this.Distinte[this.Distinte.length -1];
                this.DistintaSelezionata = this.Distinte[this.Distinte.length -1];
                this.selected = [];
                this.overlay = false;
                //window.location.href ="/#/Bollettazione";
            }
            );
    },
    Inserisci(){
      this.$router.push({ path: `/Bollettazione/0/0` })
    },
    BollettazioneRiepilogo(spedizione, stato){
      var temp = this.decodificaStato[stato];
      this.$router.push({ path: `/Bollettazione/${spedizione}/${temp}`});
    },
    
    SelezionaTutto(items){
      this.selezionati = [];
      this.totaleColli = 0;
      this.totaleSpedizioni = 0;
      this.totalePeso = 0;
      this.totaleVolume = 0;
      this.totaleContrassegno = 0;
      items.forEach(el=>{
        if(el.stato !== "INVIATA"){
          this.totaleColli += el.numcol;
          this.totaleSpedizioni += 1;
          this.totalePeso += el.pesokg;
          this.totaleVolume += el.volmec;
          this.totaleContrassegno += el.contra;
          this.selezionati.push(el);
        }
      })
    },
    test(selezionato, item){
      if(!selezionato){
        
        this.totaleColli += item.numcol;
        this.totaleSpedizioni += 1;
        this.totalePeso += item.pesokg;
        this.totaleVolume += item.volmec;
        this.totaleContrassegno += item.contra;
      }
      else{
       
          this.totaleColli -= item.numcol;
          this.totaleSpedizioni -= 1;
          this.totalePeso -= item.pesokg;
          this.totaleVolume -= item.volmec;
          this.totaleContrassegno -= item.contra;
      }
    },
    InvioBolle(){
      this.overlay = true;
      this.erroreStati = false;
      var test = [];
      this.selezionati.forEach(ele => {
        if(ele.stato!=='SEGN.LI STAMPATI') 
          this.erroreStati = true;
        else{
          var el = ele;
          el.stato = 2;
          test.push(el);
        }
      })
      if(!this.erroreStati){
        
        axios.put(this.$store.state.servicePath + "/api/ArBolleSpes", test).
                then(res=> {
                  
                    if(res.data === "OK"){
                      this.StampaInvioBolle();
                      //this.StampaInvioBolle()
                      
                }
                else{
                  this.overlay = false;
                  this.testoErroreInvio = res.data;
                  this.erroreInvioDialog = true;
                  this.Cerca();
                }
                })
                .catch(err=>{
                  this.overlay = false;
                  
                  this.testoErroreInvio = "Gentile utente,</br>sono stati riscontrati problemi durante l'invio delle tue bolle.</br>Prova di nuovo o contatta l'assistenza.";
                  this.erroreInvioDialog = true;
                  this.Cerca();
                });
      }
      else{
        this.overlay = false;
        this.erroreStatiDialog = true;
      }
    },
    CheckJWT() {
      axios
        .post(this.$store.state.servicePath + "/api/Login/checkJwt", {
          route: this.$route.path
        })
        .then(res => {
          if (res.data.status == "ko") {
            this.$router.push({ path: `/errore` });
          }
        })
        .catch(err =>{
          this.$router.push({ path: `/errore` });
        });
    },
    StampaLdv(numsped){
      this.overlay = true;
      var sped = [];
      // this.selezionati.forEach(el=>{
      //   if(!sped.includes(el.numspe))
      //     sped.push(el.numspe);
      // })
      sped.push(numsped);
      
      axios.post(this.$store.state.servicePath + "/api/Print", sped)
      .then(res=>{
        var pdf = res.data;
        this.overlay = false;
        var decodedString = atob(pdf);
        var byteCharacters = decodedString;
        var byteNumbers = new Array(byteCharacters.length);
        // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          for (var i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
          var byteArray = new Uint8Array(byteNumbers);
          var blob = new Blob([byteArray], {
              type: 'application/pdf'
          });
          const fileObjectURL = URL.createObjectURL(blob); 
          window.open(fileObjectURL)
        //   window.navigator.msSaveOrOpenBlob(blob, "LDV_" + numsped + ".pdf");
        // }
        //window.open("data:application/pdf;base64, " + pdf);
        // else{
        //   var pdfWindow = window.open("pdf", '_blank');
        //   pdfWindow.document.write("<iframe width='100%' height='100%' src='data:application/pdf;base64, " + pdf+"'></iframe>")
        // }
        
      })
      .catch(error => {
        this.overlay = false;
        this.erroreStampa = "Si è verificato un errore durante la stampa delle LDV. <br>Verifica che i blocchi pop-up del tuo browser siano disattivi.<br>Se il problema persiste, contattare l'assitenza Arco Spedizioni";
        this.mostraErrore = true;
      });
      
    },
    StampaDistinta(distinta){
      this.overlay = true;
      var sped = [];
      sped.push(distinta);
      if(this.ristampaLDV){
        axios.post(this.$store.state.servicePath + "/api/Print/LDVeDistinte", sped)
        .then(res=>{
          var pdf = res.data;
          this.overlay = false;
          var decodedString = atob(pdf);
          var byteCharacters = decodedString;
          var byteNumbers = new Array(byteCharacters.length);
          // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            for (var i = 0; i < byteCharacters.length; i++) {
                  byteNumbers[i] = byteCharacters.charCodeAt(i);
              }
            var byteArray = new Uint8Array(byteNumbers);
            var blob = new Blob([byteArray], {
                type: 'application/pdf'
            });
            const fileObjectURL = URL.createObjectURL(blob); 
            window.open(fileObjectURL)
        })
        .catch(error => {
          this.overlay = false;
          this.erroreStampa = "Si è verificato un errore durante la stampa della Distinta. <br>Verifica che i blocchi pop-up del tuo browser siano disattivi.<br>Se il problema persiste, contattare l'assitenza Arco Spedizioni";
          this.mostraErrore = true;
        });   
      }
      else{
        axios.post(this.$store.state.servicePath + "/api/Print/Distinte", sped)
        .then(res=>{
          var pdf = res.data;
          this.overlay = false;
          var decodedString = atob(pdf);
          var byteCharacters = decodedString;
          var byteNumbers = new Array(byteCharacters.length);
          // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            for (var i = 0; i < byteCharacters.length; i++) {
                  byteNumbers[i] = byteCharacters.charCodeAt(i);
              }
            var byteArray = new Uint8Array(byteNumbers);
            var blob = new Blob([byteArray], {
                type: 'application/pdf'
            });
            const fileObjectURL = URL.createObjectURL(blob); 
            window.open(fileObjectURL)
          //   window.navigator.msSaveOrOpenBlob(blob, "Distinta_" + distinta + ".pdf");
          // }
          //window.open("data:application/pdf;base64, " + pdf);
          // else{
          //   var pdfWindow = window.open("pdf", '_blank');
          //   pdfWindow.document.write("<iframe width='100%' height='100%' src='data:application/pdf;base64, " + pdf+"'></iframe>")
          // }
        })
        .catch(error => {
          this.overlay = false;
          this.erroreStampa = "Si è verificato un errore durante la stampa della Distinta. <br>Verifica che i blocchi pop-up del tuo browser siano disattivi.<br>Se il problema persiste, contattare l'assitenza Arco Spedizioni";
          this.mostraErrore = true;
        });   
      }   
    },
    StampaEtichette(numsped){
      this.overlay = true;
      var sped = [];
      // this.selezionati.forEach(el=>{
      //   if(!sped.includes(el.numspe))
      //     sped.push(el.numspe);
      // })
      sped.push(numsped);
      
      axios.post(this.$store.state.servicePath + "/api/Print/Etichette", sped)
      .then(res=>{
        var pdf = res.data;
        //window.open("data:application/pdf;base64, " + res.data);
       var decodedString = atob(pdf);
        var byteCharacters = decodedString;
        var byteNumbers = new Array(byteCharacters.length);
        // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          for (var i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
          var byteArray = new Uint8Array(byteNumbers);
          var blob = new Blob([byteArray], {
              type: 'application/pdf'
          });
          const fileObjectURL = URL.createObjectURL(blob); 
          window.open(fileObjectURL)
          //window.navigator.msSaveOrOpenBlob(blob, "Etichette_" + numsped + ".pdf");
        // }
        //window.open("data:application/pdf;base64, " + pdf);
        // else{
        //   var pdfWindow = window.open("pdf", '_blank');
        //   pdfWindow.document.write("<iframe width='100%' height='100%' src='data:application/pdf;base64, " + pdf+"'></iframe>")
        // }
        this.AggiornaStato(sped);
        
      })
      .catch(error => {
        this.overlay = false;
        this.erroreStampa = "Si è verificato un errore durante la stampa delle etichette 10x10. <br>Verifica che i blocchi pop-up del tuo browser siano disattivi.<br>Se il problema persiste, contattare l'assitenza Arco Spedizioni";
        this.mostraErrore = true;
      });
      
    },
    StampaEtichetteMultiple(){
      this.overlay = true;
      var sped = [];
      this.selezionati.forEach(el=>{
        if(!sped.includes(el.numspe) && (el.stato === "INSERITA" || el.stato === "SEGN.LI STAMPATI"))
          sped.push(el.numspe);
      })
      //sped.push(numsped);
      if(sped.length > 0){
        axios.post(this.$store.state.servicePath + "/api/Print/Etichette", sped)
        .then(res=>{
          var pdf = res.data;
          //window.open("data:application/pdf;base64, " + res.data);
          var decodedString = atob(pdf);
        var byteCharacters = decodedString;
        var byteNumbers = new Array(byteCharacters.length);
        //if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          for (var i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
          var byteArray = new Uint8Array(byteNumbers);
          var blob = new Blob([byteArray], {
              type: 'application/pdf'
          });
          const fileObjectURL = URL.createObjectURL(blob); 
          window.open(fileObjectURL)
          //window.navigator.msSaveOrOpenBlob(blob, "Etichette_Multiple.pdf");
        //}
        //window.open("data:application/pdf;base64, " + pdf);
        // else{
        //   var pdfWindow = window.open("pdf", '_blank');
        //   pdfWindow.document.write("<iframe width='100%' height='100%' src='data:application/pdf;base64, " + pdf+"'></iframe>")
        // }
          this.AggiornaStato(sped);
        })
        .catch(error => {
          this.overlay = false;
        this.erroreStampa = "Si è verificato un errore durante la stampa delle etichette 10x10. <br>Verifica che i blocchi pop-up del tuo browser siano disattivi.<br>Se il problema persiste, contattare l'assitenza Arco Spedizioni";
        this.mostraErrore = true;
        });
        
      }
      else{
        this.overlay = false;
        this.erroreStampa = "Non hai selezionato nessuna spedizione di cui sia possibile stampare i segnacolli";
        this.mostraErrore = true;
      }
      
    },
    ChiediPosizioneEtichetta(){
      if(this.permessoStampaPosizionale === 1 || this.permessoStampaPosizionale === "1")
        this.DialogPosizioneEtichetta = true;
      else{
        this.StampaEtichetteMultipleA4();
      }
    },
    ChiediPosizioneEtichettaSingola(numsped){
      if(this.permessoStampaPosizionale === 1 || this.permessoStampaPosizionale === "1"){
        this.DaStampare = numsped;
        this.DialogPosizioneEtichetta2 = true;
      }
      else{
        this.DaStampare = numsped;
        this.StampaEtichetteA4()
      }
    },
    StampaEtichetteA4(){
      this.$refs.posizione_etichetta.resetValidation();
      this.overlay = true;
      var sped = [];
      if(this.posizioneStampa === null || this.posizioneStampa === undefined || this.posizioneStampa === ""){
        this.posizioneStampa = 1;
      }
      // this.selezionati.forEach(el=>{
      //   if(!sped.includes(el.numspe))
      //     sped.push(el.numspe);
      // })
      sped.push(this.DaStampare);
      this.DaStampare = "";
      var salto = Number(this.posizioneStampa) -1;
      this.posizioneStampa = 1;
      this.Attiva(1);
      axios.post(this.$store.state.servicePath + "/api/Print/EtichetteA4/" + salto, sped)
      .then(res=>{
        var pdf = res.data;
        //window.open("data:application/pdf;base64, " + res.data);
        var decodedString = atob(pdf);
        var byteCharacters = decodedString;
        var byteNumbers = new Array(byteCharacters.length);
        // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          for (var i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
          var byteArray = new Uint8Array(byteNumbers);
          var blob = new Blob([byteArray], {
              type: 'application/pdf'
          });
          const fileObjectURL = URL.createObjectURL(blob); 
          window.open(fileObjectURL)
          //window.navigator.msSaveOrOpenBlob(blob, "EtichetteA4_" + numsped + ".pdf");
        // }
        // //window.open("data:application/pdf;base64, " + pdf);
        // else{
        //   var pdfWindow = window.open("pdf", '_blank');
        //   pdfWindow.document.write("<iframe width='100%' height='100%' src='data:application/pdf;base64, " + pdf+"'></iframe>")
        // }
        this.AggiornaStato(sped);
      })
      .catch(error => {
        this.overlay = false;
        this.posizioneStampa = 1;
        this.Attiva(1);
        this.erroreStampa = "Si è verificato un errore durante la stampa delle etichette A4. <br>Verifica che i blocchi pop-up del tuo browser siano disattivi.<br>Se il problema persiste, contattare l'assitenza Arco Spedizioni";
        this.mostraErrore = true;
      });
      
    
    },
    StampaEtichetteMultipleA4(){
      this.$refs.posizione_etichetta.resetValidation();
      this.overlay = true;
      var sped = [];
      if(this.posizioneStampa === null || this.posizioneStampa === undefined || this.posizioneStampa === ""){
        this.posizioneStampa = 1;
      }
      this.selezionati.forEach(el=>{
        if(!sped.includes(el.numspe) && (el.stato === "INSERITA" || el.stato === "SEGN.LI STAMPATI"))
          sped.push(el.numspe);
      })
      //sped.push(numsped);
      if(sped.length > 0){
        var salto = Number(this.posizioneStampa) -1;
        axios.post(this.$store.state.servicePath + "/api/Print/EtichetteA4/" + salto, sped)
        .then(res=>{
          var pdf = res.data;
          //window.open("data:application/pdf;base64, " + res.data);
          var decodedString = atob(pdf);
        var byteCharacters = decodedString;
        var byteNumbers = new Array(byteCharacters.length);
        // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          for (var i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
          var byteArray = new Uint8Array(byteNumbers);
          var blob = new Blob([byteArray], {
              type: 'application/pdf'
          });
          this.posizioneStampa = 1;
          this.Attiva(1);
          const fileObjectURL = URL.createObjectURL(blob); 
          window.open(fileObjectURL)
          //window.navigator.msSaveOrOpenBlob(blob, "EtichetteA4_Multiple.pdf");
        //}
        //window.open("data:application/pdf;base64, " + pdf);
        // else{
        //   var pdfWindow = window.open("pdf", '_blank');
        //   pdfWindow.document.write("<iframe width='100%' height='100%' src='data:application/pdf;base64, " + pdf+"'></iframe>")
        // }
          this.AggiornaStato(sped);
        })
        .catch(error => {
          this.posizioneStampa = 1;
          this.Attiva(1);
          this.overlay = false;
          this.erroreStampa = "Si è verificato un errore durante la stampa delle etichette A4. <br>Verifica che i blocchi pop-up del tuo browser siano disattivi.<br>Se il problema persiste, contattare l'assitenza Arco Spedizioni";
          this.mostraErrore = true;
        });
      }
      else{
        this.posizioneStampa = 1;
        this.Attiva(1);
        this.overlay = false;
        this.erroreStampa = "Non hai selezionato nessuna spedizione di cui sia possibile stampare i segnacolli";
        this.mostraErrore = true;
      }
      
    },
     AggiornaStato(sped){      
      axios.put(this.$store.state.servicePath + "/api/ArBolleSpes/Aggiorna/2", sped)
      .then(res=>{
        var pdf = res.data;
        this.Cerca();
        
        window.location.href ="/#/Bollettazione";
      });
      
    },
    StampaLdvMultiple(){
      this.overlay = true;
      var sped = [];
      this.selezionati.forEach(el=>{
        if(!sped.includes(el.numspe))
          sped.push(el.numspe);
      })
      axios.post(this.$store.state.servicePath + "/api/Print", sped)
      .then(res=>{
        var pdf = res.data;
        this.overlay = false;
        //window.open("data:application/pdf;base64, " + res.data);
        var decodedString = atob(pdf);
        var byteCharacters = decodedString;
        var byteNumbers = new Array(byteCharacters.length);
        // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          for (var i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
          var byteArray = new Uint8Array(byteNumbers);
          var blob = new Blob([byteArray], {
              type: 'application/pdf'
          });
          const fileObjectURL = URL.createObjectURL(blob); 
          window.open(fileObjectURL)
          //window.navigator.msSaveOrOpenBlob(blob, "LDV_Multiple.pdf");
        //}
        //window.open("data:application/pdf;base64, " + pdf);
        // else{
        //   var pdfWindow = window.open("pdf", '_blank');
        //   pdfWindow.document.write("<iframe width='100%' height='100%' src='data:application/pdf;base64, " + pdf+"'></iframe>")
        // }
      })
      .catch(error => {
        this.overlay = false;
        this.erroreStampa = "Si è verificato un errore durante la stampa delle LDV. <br>Verifica che i blocchi pop-up del tuo browser siano disattivi.<br>Se il problema persiste, contattare l'assitenza Arco Spedizioni";
        this.mostraErrore = true;
      });
      
    },
    StampaInvioBolle(){
      this.overlay = true;
      var sped = [];
      this.selezionati.forEach(el=>{
        if(!sped.includes(el.numspe))
          sped.push(el.numspe);
      })
      axios.post(this.$store.state.servicePath + "/api/Print/InvioBolle", sped)
      .then(res=>{
        var pdf = res.data;
        this.overlay = false;
        //window.open("data:application/pdf;base64, " + res.data);
        var decodedString = atob(pdf);
        var byteCharacters = decodedString;
        var byteNumbers = new Array(byteCharacters.length);
        // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          for (var i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
          var byteArray = new Uint8Array(byteNumbers);
          var blob = new Blob([byteArray], {
              type: 'application/pdf'
          });
          const fileObjectURL = URL.createObjectURL(blob); 
          window.open(fileObjectURL)
          //window.navigator.msSaveOrOpenBlob(blob, "LDV_Multiple.pdf");
        //}
        //window.open("data:application/pdf;base64, " + pdf);
        // else{
        //   var pdfWindow = window.open("pdf", '_blank');
        //   pdfWindow.document.write("<iframe width='100%' height='100%' src='data:application/pdf;base64, " + pdf+"'></iframe>")
        // }
        this.selezionati = [];     
        this.Cerca();
      })
      .catch(error => {
        this.overlay = false;
        this.erroreStampa = "Si è verificato un errore durante la stampa delle LDV. <br>Verifica che i blocchi pop-up del tuo browser siano disattivi.<br>Se il problema persiste, contattare l'assitenza Arco Spedizioni";
        this.mostraErrore = true;
      });
      
    },
    OkimportazioneFinita(){
      this.importazioneFinita = false;
      window.location.href ="/#/Bollettazione";
    },

    checkPermessi(){
      axios.get(this.$store.state.servicePath + "/api/ArUtentiPermessis/Check/IMP-EXCEL").
            then(res=> {
                this.mostra_excel = res.data;
                 axios.get(this.$store.state.servicePath + "/api/ArUtentiPermessis/Check/POSETIA4").
                  then(res=> {
                    this.permessoStampaPosizionale = res.data;
                });
          });
    },
    CancellaBolla(spedizione){
      this.dialogDelete = true;
      this.spedDelete = spedizione;
    },
    CheckDeleteBolla(){
        axios.put(this.$store.state.servicePath + "/api/ArBolleSpes/Aggiorna/8", [this.spedDelete])
        .then(res=>{
          this.dialogDelete = false;
          this.Cerca();
          window.location.href ="/#/Bollettazione";
        });
    },
    DuplicaBolla(spedizione){
      this.dialogMod = true;
      this.spedMod = spedizione;
    },
    CheckModBolla(){
      axios.put(this.$store.state.servicePath + "/api/ArBolleSpes/Aggiorna/88", [this.spedMod])
      .then(res=>{
        axios.post(this.$store.state.servicePath + "/api/ArBolleSpes/Duplica", [this.spedMod])
        .then(res=>{
          this.dialogMod = false;
          this.Cerca();
          window.location.href ="/#/Bollettazione";
        })
        
      });
    },
    PermessoStampa10(){
      axios.get(this.$store.state.servicePath + "/api/ArUtentiPermessis/Check/PRT-10x10").
            then(res=> {
              if(res.data === 1){
                this.mostra10 = res.data;
              }
              else{
                this.mostra10 = 0;
              }
              
    });
    },
  },
  watch:{
    selected: function(val) {
          //do something when the data changes.
          if (val) {
              this.SelezionaTutto(val);
          }
      },
    
    
  }
};
</script>